import styled from 'styled-components';
import { device } from '../../styles/devices';

export const Warranty = styled.h3`
  .regular {
    font-weight: normal;
  }
  .italics {
    font-style: italic;
  }
  font-family: 'Audi Type Extended';
  font-size: 10px;
  font-weight: bold;
  line-height: 18px;
  @media ${device.tablet} {
    font-size: 13px;
    line-height: 18px;
    display: flex;
    align-items: center;
    letter-spacing: -0.3px;
  }
`;
